import {pauseSvg as Icon__small__pauseSvg} from '../Icon__small/Icon__small--pause.js';

export var pause = {
  name: 'pause',
  category: 'icon',
  colorable: true,
  svg: Icon__small__pauseSvg,
};
